import { create } from "zustand";
import { persist } from "zustand/middleware";

export type RecentActivityType = "procedure" | "resource";

export interface RecentActivityItem {
    id: string;
    type: RecentActivityType;
    name: string;
    slug: string;
    timestamp: number;
    // For procedures
    specialtyCode?: string;
    specialtySlug?: string;
    specialtyName?: string;
    procedureCode?: string;
    // For resources
    resourceId?: number;
    resourceType?: "file" | "link";
}

export interface RecentActivityState {
    items: RecentActivityItem[];
    addActivity: (item: Omit<RecentActivityItem, "id" | "timestamp">) => void;
    clearActivity: () => void;
}

const MAX_ACTIVITY_ITEMS = 20;

export const useRecentActivityStore = create<RecentActivityState>()(
    persist(
        (set, get) => ({
            items: [],

            addActivity: (item) => {
                const { items } = get();
                const timestamp = Date.now();
                const id = `${item.type}-${item.slug}-${timestamp}`;

                const newItem: RecentActivityItem = {
                    ...item,
                    id,
                    timestamp,
                };

                // Remove duplicate based on slug and type
                const filteredItems = items.filter(
                    (existingItem) =>
                        !(
                            existingItem.type === newItem.type &&
                            existingItem.slug === newItem.slug
                        ),
                );

                // Add new item to the beginning and limit to MAX_ACTIVITY_ITEMS
                const newItems = [newItem, ...filteredItems].slice(
                    0,
                    MAX_ACTIVITY_ITEMS,
                );

                set({ items: newItems });
            },

            clearActivity: () => {
                set({ items: [] });
            },
        }),
        {
            name: "recent-activity",
        },
    ),
);
